import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

const Digital_api = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    fetchAccount: {
      //创建企业及游客登录
      queryDurationBalance: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/client/queryDurationBalance`,
          method: 'post',
        }),
    },
  }
}

export default Digital_api
